import { useEffect, useState } from 'react';
import { LuArrowDown, LuArrowUp } from 'react-icons/lu';
import './style.css';

const SCROLL_THRESHOLD = 520;

const ScrollToggle = ({ labels, target = 'page-bottom' }) => {
  const [isScrollUpMode, setIsScrollUpMode] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrollUpMode(window.scrollY > SCROLL_THRESHOLD);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClick = () => {
    if (isScrollUpMode) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const requestSection = target === 'home-cta'
      ? document.querySelector('.home-quote-cta')
      : null;

    if (requestSection) {
      requestSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const footer = document.querySelector('.footer');

    if (footer) {
      footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      className="scroll-toggle"
      onClick={handleClick}
      aria-label={isScrollUpMode
        ? (labels?.scrollUp || 'Прокрутить вверх')
        : (labels?.scrollDown || 'Прокрутить вниз')}
      title={isScrollUpMode
        ? (labels?.topTitle || 'Наверх')
        : (labels?.formTitle || (target === 'home-cta' ? 'К оценке проекта' : 'К низу страницы'))}
    >
      {isScrollUpMode ? <LuArrowUp /> : <LuArrowDown />}
    </button>
  );
};

export default ScrollToggle;
